import React from 'react';
import { useSelector } from 'react-redux';
import { inboxMarkAsOptions } from '../../../screens/inbox/store/inboxScreenSelectors.js';
import getInboxMessageSnippet from '../../../screens/inbox/lib/getInboxMessageSnippet.js';
import { setInboxMessageStatus } from '../../../screens/inbox/store/inboxScreenActions.js';
import SwipeableItem from '../../components/SwipableItem.js';
import { action } from '../../../lib/actionHelpers.js';
import SVG from '../../../images/svg/SVG.js';

const MobileMessage = ({ message, onClick, onReadOrUnreadToggleClick }) => {
  const markAsOptions = useSelector(inboxMarkAsOptions(message.message.status_id));

  const snippet = getInboxMessageSnippet(message);
  const readUnreadTitle = String(message.message.is_read || '0') === '0' ? 'Mark as Read' : 'Mark as Unread';
  const profileImageUrl = ((message.message || {}).thread_meta || {}).profile_image_url;
  const platform = message.message.platform || {};
  const detailType = ['facebookmessenger'].includes(platform.code) ? platform.code : message.type;
  const isLead = !!message.message.lead_id;

  const handleMarkAsChange = (option) => {
    setInboxMessageStatus(message, option.id);
  };

  const handleReadOrUnreadClick = () => {
    action('SET_MESSAGE_HIDDEN', { message: message.message, hidden: true });
    setTimeout(() => {
      onReadOrUnreadToggleClick(null, message);
    }, 300);
  };

  const handleMarkAsClick = (opts, n) => {
    action('SET_MESSAGE_HIDDEN', { message: message.message, hidden: true });
    handleMarkAsChange(n);
  };

  const actions = [{ type: 'trailing', label: 'Mark Read', destructive: false, color: 'blue', onClick: handleReadOrUnreadClick }, ...markAsOptions.filter((n) => !isLead).map((n) => ({ type: 'leading', label: n.label, destructive: false, color: n.color, onClick: (data) => handleMarkAsClick(data, n) }))];

  return (
    <SwipeableItem actions={actions} fullSwipe={false}>
      <div className={`mobile-inbox-message ${message.active ? 'active' : ''} ${message.message.hidden ? 'hidden' : ''} ${detailType} ${isLead ? 'lead' : ''}`} onClick={onClick}>
        <div className="icon-wrapper">
          {profileImageUrl && (
            <div className="profile-image">
              <img alt="Profile" src={profileImageUrl} />
            </div>
          )}
          {!profileImageUrl && (
            <div className="icon">
              {message.svg && <SVG icon={message.svg} />}
              {/*<img src={message.typeIcon} alt={message.type} />*/}
            </div>
          )}
        </div>
        <div className="content-wrapper">
          <div className="heading">
            {message.name}
            {isLead && (
              <div className={`read-unread-bubble ${message.isRead ? 'read' : 'unread'}`} onClick={(e) => onReadOrUnreadToggleClick(e, message)} data-title={readUnreadTitle}>
                <div />
              </div>
            )}
          </div>
          <div className="subheading"></div>
          <div className="snippet">{snippet}</div>
          <div className="controls">
            <div className="comment" data-title={message.fullDate}>
              {message.date}
            </div>
          </div>
        </div>
      </div>
    </SwipeableItem>
  );
};

export default MobileMessage;
